import warning from "warning"
import omitBy from "lodash/omitBy"
import { normalize as normalizeModel } from "src/engine/modules/model/helpers"
import { affective } from "../../actions/types"
import item from "../item"

const INITIAL_STATE = {
  model: null,
  items: {},
}

export default function entity(state = INITIAL_STATE, action) {
  const { model } = action

  const { name } = normalizeModel(model)

  warning(
    state.model === null || state.model === model,
    `Entity '${name}' already exists in store and it is different`,
  )

  const { id } = action

  /* Remove item */
  if (
    action.type === affective.release &&
    state.items[id] &&
    (state.items[id].involved <= 1 || action.force)
  ) {
    return {
      ...state,
      items: omitBy(state.items, (item, key) => key === id),
    }
  }

  const nextItem = item(state.items[id], action)

  return nextItem === state.items[id]
    ? state
    : {
        ...state,
        model,
        items: {
          ...state.items,
          [id]: nextItem,
        },
      }
}
